import PropTypes from 'prop-types';
import classnames from 'classnames/bind';
import { LayoutDirection } from 'app/lib/constants';
import * as styles from './FieldLayout.css';

const cx = classnames.bind(styles);

const DIRECTION_CLASSES = {
    [LayoutDirection.COLUMN]: 'dir-column',
    [LayoutDirection.ROW]: 'dir-row'
};

export function FieldLayout({
    testId,
    className,
    direction = LayoutDirection.COLUMN,
    children,
    ...props
}) {
    const classes = cx(DIRECTION_CLASSES[direction], className);

    return (
        <div data-testid={testId} className={classes} {...props}>
            {children}
        </div>
    );
}

FieldLayout.propTypes = {
    /**
     * Emit a `data-testid` prop on the root element of the component. Use this
     * to help automated testing tools find this particular component.
     */
    testId: PropTypes.string,

    /**
     * Set additional CSS classes on the component to extend the default styles.
     */
    className: PropTypes.string,

    /**
     * Direction to layout the children. Take care not to use horizontal
     * layouts with more than 2 or 3 fields.
     */
    direction: PropTypes.oneOf(Object.values(LayoutDirection)),

    children: PropTypes.node
};
